/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".message[_ngcontent-%COMP%]{padding-bottom:1rem;text-align:start}"];
export { styles as styles };
